// extracted by mini-css-extract-plugin
export default {"ModalContainer":"bK6nvv_HnZqvOiGAcYA1","ModalContent":"mHNtwMRmha88_T4EYLTo","ModalContent__center":"Zpq9kYpiSC7fsCY3Fek0","ModalContent__morePadding":"cYe9tPCxXDONRpWjZAVm"};